export const nrsUsdtpPricePrecision = 6;
